import { ContentRoute } from "../../models/Route";
import PipelineList from "./pipelineList";
import PipelineForm from "./pipelineForm";
import LojaForm from "./lojaForm";
import PipelineFlow from "./pipelineFlow";
import ConfigDiff from "./configDiff";

const infra_content_routes: Array<ContentRoute> = [
    {
        'path': '/infra',
        'description': 'Central de Infra',
        'exact': true,
        'component': PipelineList,
        'menu': true
    },
    {
        'path': '/infra/novo',
        'description': 'Novo cliente',
        'exact': true,
        'component': PipelineForm,
        'menu': false
    },
    {
        'path': '/infra/loja/nova',
        'description': 'Nova loja',
        'exact': true,
        'component': LojaForm,
        'menu': false
    },
    {
        'path': '/infra/pipeline/:id/config',
        'description': 'Configuracoes',
        'exact': true,
        'component': ConfigDiff,
        'menu': false
    },
    {
        'path': '/infra/pipeline/:id',
        'description': 'Pipeline',
        'exact': true,
        'component': PipelineFlow,
        'menu': false
    },
]

export default infra_content_routes;
